// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "44ad1d3/js/" + chunkId + ".js";
};